import { z } from 'zod/v4';

export const DeleteEmployeeParamsSchema = z.object({
  employeeId: z.string().min(1, 'Employee ID is required'),
});

export type DeleteEmployeeParams = z.infer<typeof DeleteEmployeeParamsSchema>;
